﻿let index = 0;

export default () => {
    index += 1;
    return `ra-js${index}`;
}
